import Raven from 'raven-js';
import { Metrics } from '../metrics/Metrics';
export const fetchDecryptedHighlySensitivePropertyValue = ({
  objectTypeId,
  objectId,
  propertyName,
  timestamp,
  httpClient
}) => {
  return httpClient.get(`inbounddb-objects-sensitive/v1/decrypted/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}/${encodeURIComponent(propertyName)}`, timestamp ? {
    query: {
      timestamp
    }
  } : {}).then(response => {
    Metrics.counter('fetchdecryptedhighlysensitivepropertyvalue-success').increment();
    if (!response) {
      return '';
    }
    return response.value || '';
  }).catch(err => {
    Metrics.counter('fetchdecryptedhighlysensitivepropertyvalue-failure').increment();
    Raven.captureException(err, {
      extra: {
        apiError: 'DECRYPT_HIGHLY_SENSITIVE_PROPERTY_VALUE_FAILED',
        objectId,
        objectTypeId,
        propertyName
      }
    });
    throw err;
  });
};